<template>
  <div id="app">
    <!-- <index /> -->
    <distribution />
    <!-- 将上传组件全局注册 -->
    <!-- <global-uploader/> -->
  </div>
</template>

<script>
import Distribution from "./components/distribution.vue";
import GlobalUploader from "./components/globalUploader.vue";
import Index from "./components/index.vue";
export default {
  name: "App",
  components:{
    Index,
    Distribution,
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
